import config from '../config';

export const track = (event, properties) => {
    if (config.currentEnv === 'production') {
        window.analytics.track(event, properties);
    }
}